export { default as TeamSelector } from "@/features/team-selection/components/organisms/TeamSelector";
